const LVUrgentCareLight = () => (
	<path
		d="M13.66 26.96V20.07L7.69999 23.51C7.19999 23.8 6.55999 23.63 6.26999 23.13L4.97999 20.9C4.68999 20.4 4.85999 19.76 5.35999 19.47L11.33 15.99L5.36999 12.55C4.86999 12.26 4.69999 11.62 4.98999 11.12L6.27999 8.9C6.56999 8.4 7.20999 8.23 7.70999 8.52L13.67 11.96V5.04C13.67 4.46 14.14 4 14.71 4H17.29C17.87 4 18.33 4.47 18.33 5.04V11.96L24.29 8.52C24.79 8.23 25.43 8.4 25.72 8.9L27.01 11.12C27.3 11.62 27.13 12.26 26.63 12.55L20.67 15.99L26.64 19.47C27.14 19.76 27.31 20.4 27.02 20.9L25.73 23.13C25.44 23.63 24.8 23.8 24.3 23.51L18.34 20.07V26.96C18.34 27.54 17.87 28 17.3 28H14.72C14.14 28 13.68 27.53 13.68 26.96H13.66Z"
		fill="white"
	/>
);

export default LVUrgentCareLight;
